// extracted by mini-css-extract-plugin
module.exports = {"content":"aee5b7c44e--content--j0VLE","average-price":"aee5b7c44e--average-price--QgbzV","quick-links":"aee5b7c44e--quick-links--rCZ44"};